<div class="modal-header">
    <h4 class="modal-title">{{ "modales.deleteAccount.title" | translate }}</h4>
</div>
<div class="modal-body">
    <div class="contentContainer">
        <div class="text">
            {{ "modales.deleteAccount.message" | translate }}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="validate()" type="button" class="btn btn-danger">
        {{ "modales.deleteAccount.confirm" | translate }}
    </button>
    <button (click)="cancel()" type="button" class="btn btn-secondary">
        {{ "modales.deleteAccount.cancel" | translate }}
    </button>
</div>
